"use strict";

var ZONE_SELECTOR_DISMISSED_KEY = "zone-selector-modal-dismissed";

function hasDismissedZoneSelectorModal() {
    return localStorage.getItem(ZONE_SELECTOR_DISMISSED_KEY) === "true";
}

function markZoneSelectorModalAsDismissed() {
    localStorage.setItem(ZONE_SELECTOR_DISMISSED_KEY, "true");
}

function initDisplayModalCheckoutListeners() {
    // O modal é injetado por remote include (Stores-ZoneSelectorFooter?checkout=true) e pode
    // não existir no init: resolver no clique. Sem o modal de checkout, abre o genérico.
    function resolveCheckoutModal() {
        var $modal = $(".js-region-selector-checkout-modal");
        return $modal.length ? $modal : $(".js-region-selector-modal");
    }

    // Bootstrap 4: Modal.show() aborta com "if (this._isTransitioning || this._isShown) return".
    // Um modal .fade cuja transição nunca terminou (show() e hide() em sequência rápida, ou
    // display:none) deixa _isTransitioning preso e nunca mais abre, sem erro no console.
    function resetStuckModalState($modal) {
        var bsModal = $modal.data("bs.modal");
        if (bsModal && !$modal.hasClass("show")) {
            bsModal._isTransitioning = false;
            bsModal._isShown = false;
        }
    }

    // Backdrop órfão de outro modal (o de estoque fecha por código) intercepta os cliques.
    function removeOrphanBackdrop() {
        if (!$(".modal.show").length) {
            $(".modal-backdrop").remove();
            $("body").removeClass("modal-open").css("padding-right", "");
        }
    }

    $("body").on("click", ".js-btn-change-region-checkout", function () {
        $(this).attr("data-trigger", true);

        var $modal = resolveCheckoutModal();
        if (!$modal.length) {
            return;
        }

        removeOrphanBackdrop();

        $modal.off("hidden.bs.modal.zoneCheckout").on("hidden.bs.modal.zoneCheckout", function () {
            $(".js-btn-change-region-checkout").attr("data-trigger", false);
        });

        resetStuckModalState($modal);

        // Se o usuário fechar o modal dentro dos 250 ms, hide() já removeu a classe `show`
        // e o retry o reabriria. hide.bs.modal marca esse fechamento e cancela o retry.
        var closedSinceClick = false;
        $modal.off("hide.bs.modal.zoneCheckoutRetry").one("hide.bs.modal.zoneCheckoutRetry", function () {
            closedSinceClick = true;
        });

        $modal.modal("show");

        // O primeiro show() da sessão pode marcar as flags e mesmo assim não mostrar o modal.
        // Se em 250 ms ele segue oculto e ninguém o fechou, limpa e tenta uma única vez.
        setTimeout(function () {
            $modal.off("hide.bs.modal.zoneCheckoutRetry");
            if (closedSinceClick || $modal.hasClass("show")) {
                return;
            }
            resetStuckModalState($modal);
            removeOrphanBackdrop();
            $modal.modal("show");
        }, 250);
    });
}

function initDisplayModalListeners() {
    const $removeRecipeModal = $(".js-region-selector-modal");

    $(".js-btn-change-region").on("click", function () {
        $(this).attr("data-trigger", true);
        $removeRecipeModal.modal("show");
    });

    $removeRecipeModal.on("hidden.bs.modal", function () {
        $(".js-btn-change-region").attr("data-trigger", false);
    });

    $removeRecipeModal.on("hidden.bs.modal", function () {
        markZoneSelectorModalAsDismissed();
    });
}

function getCommuneList($form, value) {
    const optionsList = $form.data("options-list");
    const commune = optionsList.find((item) => item && item.name === value);
    const communeList = commune.sectorList || [];

    return communeList;
}

function populateCommuneSelector($form, communeList) {
    const $communeSelect = $form.find(".js-commune-select");
    $communeSelect.html("");

    for (let commune of communeList) {
        $communeSelect.append(`<option value="${commune.name}">${commune.name}</option>`);
    }
}

function initChangeRegionListeners() {
    function showStockCheckingModal() {
        var $checkingModal = $(".js-stock-checking-modal");
        if ($checkingModal.length) {
            $checkingModal.modal("show");
        }
    }

    function hideStockCheckingModal() {
        var $checkingModal = $(".js-stock-checking-modal");
        if ($checkingModal.length) {
            $checkingModal.modal("hide");
        }
    }

    $(".js-region-select").on("change", function () {
        const $this = $(this);
        const value = $this.val();
        const $form = $this.closest(".change-region-form");

        const communeList = getCommuneList($form, value);
        populateCommuneSelector($form, communeList);
    });

    $(".js-btn-save-region").on("click", function (e) {
        e.preventDefault();

        const $this = $(this);
        const url = $this.data("url");
        const $modal = $this.closest(".js-region-selector-modal");
        const $regionSelect = $modal.find(".js-region-select");
        const $communeSelect = $modal.find(".js-commune-select");
        const region = $regionSelect.val();
        const commune = $communeSelect.val();

        if (region && commune) {
            showStockCheckingModal();
            $.ajax({
                url: url,
                type: "post",
                data: { state: region, city: commune },
                success: function (data) {
                    if (data.success) {
                        markZoneSelectorModalAsDismissed();
                        $modal.modal("hide");
                        window.location.reload();
                    } else {
                        hideStockCheckingModal();
                    }
                },
                error: function (err) {
                    hideStockCheckingModal();
                    console.log(err);
                }
            });
        }
    });

    $(".js-btn-save-region-checkout").on("click", function (e) {
        e.preventDefault();

        const $this = $(this);
        const url = $this.data("url");
        const $modal = $this.closest(".js-region-selector-checkout-modal");
        const $regionSelect = $modal.find(".js-region-select");
        const $communeSelect = $modal.find(".js-commune-select");
        const region = $regionSelect.val();
        const commune = $communeSelect.val();

        if (region && commune) {
            showStockCheckingModal();
            $.ajax({
                url: url,
                type: "post",
                data: { state: region, city: commune },
                success: function (data) {
                    if (data.success) {
                        markZoneSelectorModalAsDismissed();
                        $modal.modal("hide");
                        window.location.reload();
                    } else {
                        hideStockCheckingModal();
                    }
                },
                error: function (err) {
                    hideStockCheckingModal();
                    console.log(err);
                }
            });
        }
    });
}

module.exports = {
    initDisplayModalListeners: initDisplayModalListeners,
    initDisplayModalCheckoutListeners: initDisplayModalCheckoutListeners,
    initChangeRegionListeners: initChangeRegionListeners
};
